import { QUESTION_NEST_PEEQ } from 'data/nodeTypes';
import targetingCriterionValidator from './targetingCriterionValidator';
import ageCriterionValidator from './ageCriterionValidator';
import nestingCriterionValidator from './nestingCriterionValidator';

const validateCriterion = (criterion, { completes }) => {
  switch (criterion.style) {
    // TODO: there is one more id that have age range, and is not allowed to add more ranges than one
    case 'Numeric': {
      return ageCriterionValidator(criterion, {
        completes,
      });
    }
    case QUESTION_NEST_PEEQ: {
      return nestingCriterionValidator(criterion, {
        completes,
      });
    }
    default:
      return targetingCriterionValidator(criterion, {
        completes,
      });
  }
};

export { validateCriterion };
